import get from 'lodash/get';

function retrieveActivationsSuccess(context, { response }) {
    const activations = response.data;
    context.dispatch('SET_ACTIVATIONS', activations);
}
retrieveActivationsSuccess.displayName = 'retrieveActivationsSuccess';

export default config => ({
    serviceName: 'tenant.activation.retrieveActivations',
    authenticate: true,
    config: {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'GET',
        url: get(config, 'endpoints.pulse.tenant.activation.retrieve'),
    },
    onSuccess: retrieveActivationsSuccess,
});
